import React from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, NavbarBrand, Alert } from 'reactstrap';
import Footer from '@components/Footer';

class ComplianceVerificationFailure extends React.Component {
    render() {
        return (
            <div className="simple-page">
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container>
                    <Row>
                        <Col>
                            <div className="card">
                                <div className="card-header">Compliance Verification Failure</div>
                                <div className="card-block">
                                    <Row>
                                        <Col>
                                            <p>Compliance Verification failure. The token is incorrect or expired.</p>
                                            <p>Please email support@corlytics.com for assistance</p>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}

export default ComplianceVerificationFailure;



// WEBPACK FOOTER //
// ./src/views/Pages/ComplianceVerificationFailure/ComplianceVerificationFailure.js